import * as Yup from 'yup';
import { createYupSchema } from './yupSchemaCreator';
export const validateTenantInfo = (tenantInfoValidation: any[]) => {
  const yepSchema = tenantInfoValidation.reduce(createYupSchema, {});
  const validateSchema = Yup.object().shape(yepSchema);
  let data = [];
  data.push(validateSchema);
  if (data.length > 0) {
    return data;
  }
};
